<div id="login">
  <ngx-loading-bar
    #loading
    color="#3AA36B"
    includeSpinner="false"
    height="3px"
  ></ngx-loading-bar>

  <div class="container-fluid">
    <div class="row">
      <div class="col bg-logo">
        <div class="logo">
          <img src="./assets/logo.svg" />

          <h2>FIELD SERVICE</h2>
        </div>
      </div>

      <div class="col">
        <form [formGroup]="loginForm">
          <h3>Faça o seu login</h3>

          <div class="form-group">
            <label>Usuário RD</label>

            <input type="text" formControlName="username" autofocus />
          </div>

          <div class="form-group">
            <label>Senha RD</label>

            <input type="password" formControlName="password" />
          </div>

          <button [disabled]="loginForm.invalid" (click)="login()">
            Entrar
          </button>

          <div class="message">{{ message }}</div>
        </form>
      </div>

      <footer>
        RaiaDrogasil S.A. - Todos os direitos reservados - {{ buildVersion }}
      </footer>
    </div>
  </div>
</div>
